import styled from '@emotion/styled'

const TopBarMenuDivider = styled.div`
  background: #eaedf3;
  height: 38px;
  width: 1px;
  margin: 0 30px 0 70px;
  flex-basis: 1px;
  flex-shrink: 0;
`

export default TopBarMenuDivider
